import Button from "../../../Buttons/Button";
import React, {
  FormEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { IGroupProps, IStaysReservationProps } from "../../../../interfaces";
import { Form } from "./style";
import { GenericForm, IGenericFormRefProps } from "../../../GenericForm";
import { validateCPF, validateEmail, validatePhoneWithDDI } from "../../../../utils/validatesFields";
import { uniqueId } from "lodash";
import { maskFunctions } from "../../../../services/maskServices";
import { FormCheckIn } from "../checkInForm";
import { Alert, Flex, Text } from "@mantine/core";
import { FiAlertCircle } from "react-icons/fi";
import Input from "../../../Inputs/Input";
import { FaBook, FaRegCopy, FaWhatsapp } from "react-icons/fa";
import { useWallet } from "../../../../hooks/wallet";
import { mediator } from "../../../../utils/mediator";
import { BlockForm } from "../../../BlockForm";
import { DropdownButton } from "../../../Buttons/DropdownButton";
import { MdDelete, MdOutlineEmail } from "react-icons/md";
import { IPermissionsTypes } from "../../../../utils/permissions";
import { ModalSendWpp } from "../../ModalSendWpp";
import { ModalSendEmail } from "../../ModalSendEmail";
import { fail } from "../../../../theme";
import { IoSend } from "react-icons/io5";
import { LiaFileContractSolid } from "react-icons/lia";
import parsePhoneNumberFromString from "libphonenumber-js";
import { getNumberAndDDI } from "../../../../utils/getNumberAndDDI";

export interface IGuestsDocumentsCardRef {
  matchImages: () => Promise<{
    isVerified: any;
    idGuest: string | undefined;
    compareValid: any;
    compareScore: any;
  }>;
}

interface IGuestDataCheckMatch {
  [key: string]: {
    isVerified: any;
    idGuest: string | undefined;
    compareValid: any;
    compareScore: any;
  };
}

interface IFormReservationModalProps {
  onCancel: Function;
  onSave: Function;
  defaultData?: any;
  defaultGuests?: any[];
  isDoneCheckIn: boolean;
}

const guestsFields = [
  "name",
  "email",
  "phone",
  "ddi",
  "document_type",
  "document_value_cpf",
  "document_value_others",
];

export const guestsMediator = {
  updateGuests: (data: IGroupProps[]) => mediator.publish('guests.update', data),
  subscribe: (cb: (data: IGroupProps[]) => void) => mediator.subscribe('guests.update', cb),
  unsubscribe: (cb: (data: IGroupProps[]) => void) => mediator.unsubscribe('guests.update', cb),
};

export const FormReservation: React.FC<IFormReservationModalProps> = (
  props
) => {
  const [isOpenCheckIn, setIsOpenCheckIn] = useState<boolean>(false);

  const { onSave, defaultData, defaultGuests, isDoneCheckIn } = props;

  const { user } = useApi();
  const { business } = useGlobal();

  const [isEditPermitted] = useState(user?.user_type?.permissions?.includes("STAYS-RESERVATIONS-UPDATE"));

  const disabledCheckin = business?.constants?.ENABLED_CHECK_ONLY_STATUS_RESERVED === 1 && defaultData?.reservation_status !== 'booked'

  const [selectedCheckInSendEmail, setSelectedCheckInSendEmail] = useState<{ id: string, reservation_stays_id: string } | null>(null);
  const [selectedCheckInSendWpp, setSelectedCheckInSendWpp] = useState<{ id: string, reservation_stays_id: string } | null>(null);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
    unregister,
    clearErrors,
  } = useForm({
    defaultValues: defaultData?.reservation_stays_id ? defaultData : ({} as any),
    mode: "all",
  });

  const _form = watch();

  const { subscription } = useWallet();
  const { api } = useApi();
  const { theme, notify, notifyBottom } = useGlobal();

  const isHaveAcessInstructionsPermission = subscription?.plans?.permissions.includes("ACCESS_INSTRUCTIONS");

  const generateGuestGroup = (defaultId?: string) => {
    const _uniqueId = defaultId ? defaultId : uniqueId();

    const newGuestGroup: IGroupProps = {
      name: "",
      label: "",
      uniqueId: _uniqueId,
      fields: [
        [
          {
            name: "name-" + _uniqueId,
            label: "Nome",
            type: "input",
            required: true,
            get_enabled_change_form_type: () => false,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "email-" + _uniqueId,
            label: "Email",
            type: "input",
            validate: validateEmail,
            required: true,
            getIsDisabled: () => !isEditPermitted,
          },
        ],
        [
          {
            name: "document_type-" + _uniqueId,
            label: "Tipo do Documento",
            type: "select-fixed",
            isClearable: true,
            options: [
              { label: "CPF", value: "cpf" },
              { label: "Passaporte", value: "passport" },
            ],
            required: true,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "document_value_cpf-" + _uniqueId,
            label: "Documento",
            type: "input",
            mask: "cpf",
            required: true,
            validate: validateCPF,
            getIsDisabled: (data) => !data["document_type-" + _uniqueId]?.value || !isEditPermitted,
            canSee: (data) =>
              data["document_type-" + _uniqueId]?.value === "cpf",
          },
          {
            name: "document_value_others-" + _uniqueId,
            label: "Documento",
            type: "input",
            required: true,
            getIsDisabled: (data) => !data["document_type-" + _uniqueId]?.value || !isEditPermitted,
            canSee: (data) =>
              data["document_type-" + _uniqueId]?.value !== "cpf",
          },
          {
            name: "ddi-" + _uniqueId,
            label: "País",
            type: "select-country",
            required: false,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "phone-" + _uniqueId,
            label: "Telefone",
            type: "phone-adm",
            mask: defaultData?.guests?.filter((guest: any) =>!guest?.phone?.includes("+55"))?.length > 0 ? undefined : "phone",
            required: true,
            getIsDisabled: () => !isEditPermitted,
            validate: defaultData?.guests?.filter((guest: any) =>!guest?.phone?.includes("+55"))?.length > 0 ? async () => true : validatePhoneWithDDI,
          }
        ],
      ],
    };

    return newGuestGroup;
  };

  const [loadingSave, setLoadingSave] = useState(false);
  const [guestsGroups, setGuestsGroups] = useState<IGroupProps[]>(() => {
    if (defaultGuests && defaultGuests.length > 0) {
      const _guestsGroups: any[] = [];

      const _defaultDataGuests = defaultGuests ?? [];
      _defaultDataGuests.forEach((executor: any) => {
        _guestsGroups.push(generateGuestGroup(executor.uniqueId));
      });

      return _guestsGroups;
    }
    return [];
  });

  const form_ref = useRef<IGenericFormRefProps>(null);
  const buttonSubmitRef = useRef<HTMLButtonElement>(null);
  const guestsRefs = useRef<IGenericFormRefProps[]>([]);

  const guestsDocumentsRefs = useRef<IGuestsDocumentsCardRef[]>([]);

  const onSubmit = useCallback(async () => {
    setLoadingSave(true);

    try {
      const isHaveFaceMatchPermission = subscription?.plans?.permissions.includes("DOCUMENT_FACE_MATCH");

      let isVerified = true;
      let guestDataCheckMatch: IGuestDataCheckMatch = {};

      if (isHaveFaceMatchPermission) {
        for (const ref of guestsDocumentsRefs.current) {
          if (ref && ref.matchImages) {
            const result = await ref.matchImages();

            if (result && result.compareValid !== undefined) {
              guestDataCheckMatch = {
                ...guestDataCheckMatch,
                [String(result.idGuest)]: result,
              };

              if (isVerified && result.compareValid !== undefined) {
                isVerified = result.compareValid;
              }
            }
          }
        }
      }

      if (!isVerified) {
        notify("Biometria não correspondida!", "error");

        setLoadingSave(false);

        return;
      }

      const form = form_ref.current?.getForm();

      const guests = getGuests();

      const updatedGuests = guests.map((item) => {
        const compareScore = guestDataCheckMatch?.[item.uniqueId]?.compareScore;
        const compareValid = guestDataCheckMatch?.[item.uniqueId]?.compareValid;

        const { ddi, national } = getNumberAndDDI((item?.ddi || "+55") + (item?.phone || ""));
        const phone = ddi+ national?.replace("(", "")?.replace(")", "")?.replace(" ", "")?.replace("-", "");

        return {
          ...item,
          compare_score: compareScore || item?.compare_score,
          compare_valid: compareValid || item?.compare_valid,
          ddi: ddi || "+55",
          phone: phone,
        };
      });

      form['reservation_stays_id'] = defaultData?.reservation_stays_id;

      if (defaultData?.id) {
        await api.put(`/check-ins/${defaultData?.id}`, { guests: updatedGuests, ...form });
      } else {
        await api.post("/check-ins", { guests: updatedGuests, ...form });
      }

      if (defaultData?.id) notify("Check-in atualizado com sucesso", "success");
      else notify("Check-in criado com sucesso", "success");

      onSave();
    } catch (err: any) {
      const error = err.response ? err.response?.data : "SERVER ERROR";
      if (error.field)
        setError(error.field, { type: "manual", message: error.detail });
      else if (error.title === "Recurso não encontrado")
        setError("reservation_stays_id", {
          type: "manual",
          message: "A acomodação dessa reserva não foi encontrada!",
        });
      else if (error.title === "Recurso já existe")
        setError("reservation_stays_id", {
          type: "manual",
          message: "Check-in já cadastrado para essa reserva!",
        });
      else notify("ERRO INTERNO DO SISTEMA", "error");
    }

    setLoadingSave(false);
  }, [form_ref, _form, api, guestsRefs, defaultData]);

  const handleStopPropagation = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e?.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    [handleSubmit, onSubmit, form_ref, _form, api, guestsRefs]
  );

  const getGuests = useCallback(() => {
    const _refs = guestsRefs.current.filter((ref) => ref?.getForm());
    const guests = _refs.map((ref) => {
      const form = ref?.getForm();
      const _uniqueId = form?.uniqueId;
      const document_type = form?.["document_type-" + _uniqueId];
      const document_value =
        document_type === "cpf"
          ? form?.["document_value_cpf-" + _uniqueId]
          : form?.["document_value_others-" + _uniqueId];

      return {
        name: _form?.["name-" + _uniqueId],
        email: form?.["email-" + _uniqueId],
        phone: form?.["phone-" + _uniqueId],
        ddi: form?.["ddi-" + _uniqueId],
        document_type,
        document_value,
        document_image_front: _form?.["document-front-" + _uniqueId],
        document_image_back: _form?.["document-back-" + _uniqueId],
        selfie_image: _form?.["document-selfie-" + _uniqueId],
        compare_score: _form?.["compare-score-" + _uniqueId],
        compare_valid: _form?.["compare-valid-" + _uniqueId],
        uniqueId: _uniqueId,
      };
    });

    return guests;
  }, [guestsRefs, _form]);

  const addGuestGroup = useCallback(() => {
    const newGuestGroup = generateGuestGroup();
    setGuestsGroups((prev) => {
      return [...prev, newGuestGroup];
    });
  }, [uniqueId]);

  const removeOwnerGroup = useCallback((index: number) => {
    setGuestsGroups((prev) => {
      return prev.filter(({ uniqueId }, i) => {
        if (i !== index) return true;
        else {
          guestsFields.forEach((field) => unregister(field + "-" + uniqueId));
          clearErrors(`documents-required-guest-${uniqueId}`);
          clearErrors(`documents-required-guest-${uniqueId}`);
        }
      });
    });

    guestsDocumentsRefs.current = guestsDocumentsRefs.current.filter((_, i) => i !== index);
  }, []);

  const handleStartNewCheckIn = useCallback(async (data: any) => {
    setIsOpenCheckIn(true);

    const { reservation_stays_id } = data;
    if (!reservation_stays_id) {
      setGuestsGroups((groups) => {
        for (const group of groups)
          guestsFields.forEach((field) =>
            unregister(field + "-" + group.uniqueId)
          );
        return [];
      });
    } else {
      const _guestsData = reservation_stays_id?.guests ?? [];
      const _guestsGroups: any[] = [];

      const _guests = _guestsData.map((guest: any) => {
        const _uniqueId = uniqueId();
        const label = guest?.cpf ? "CPF" : guest?.rg ? "RG" : "Passaporte";
        const value = guest?.cpf ? "cpf" : guest?.rg ? "rg" : "passport";
        let document_value = guest?.cpf || guest?.rg || guest?.passport;

        const guestPhone = guest?.phone;
        const pn = parsePhoneNumberFromString(guestPhone || '');
        const ddi = `+${pn?.countryCallingCode}`;
        const national = pn?.formatNational();

        return {
          ["document_type-" + _uniqueId]: { label, value },
          ["document_value_cpf-" + _uniqueId]:
            value === "cpf"
              ? maskFunctions.cpf.mask(document_value)
              : document_value,
          ["document_value_others-" + _uniqueId]: document_value,
          ["name-" + _uniqueId]: guest.name,
          ["email-" + _uniqueId]: guest.email,
          ["ddi-" + _uniqueId]: ddi || "+55",
          ["phone-" + _uniqueId]: national,
          uniqueId: _uniqueId,
        };
      });

      for (const guest of _guests) {
        const _uniqueId = guest.uniqueId;

        for (const field of guestsFields) {
          setValue(field + "-" + _uniqueId, guest[field + "-" + _uniqueId]);
        }

        _guestsGroups.push(generateGuestGroup(guest.uniqueId));
      }

      setGuestsGroups(_guestsGroups);
    }
  }, [defaultData, isDoneCheckIn, isOpenCheckIn]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(defaultData?.checkinLink);
      notifyBottom("Link copiada para área de tranferência!", "success");
    } catch (err) {
      console.error("Erro ao copiar", err);
    }
  };

  const handleConfirmDeleteCheckIn = useCallback(
    async (id: string) => {
      setLoadingSave(true);

      try {
        await api.delete(`/check-ins/${id}`);

        notify("Check-in excluído com sucesso!", "success");
      } catch (error: any) {
        const default_message = "Erro ao excluir a check-in!";
        const message = error.response?.data?.detail ?? default_message;
        notify(message, message === default_message ? "error" : "alert");
      }

      setLoadingSave(false);
    },
    [defaultData]
  );

  const alertDelete = useCallback(
    async (item: any): Promise<void> => {
      const result = window.confirm(
        "Tem certeza que deseja excluir o check-in da reserva " +
        item?.reservation_stays_id_code
      );

      if (result) handleConfirmDeleteCheckIn(item.check_in_id as unknown as string);
    },
    [handleConfirmDeleteCheckIn]
  );

  const groupsReservations: IGroupProps[] = [
    {
      name: "",
      label: "Dados da reserva",
      description: "Confira os principais dados da reserva",
      icon: FaBook,
      fields: [
        [
          {
            name: "reservation_stays_id_name",
            label: "Reserva",
            type: "input",
            getIsDisabled: () => !!defaultData?.reservation_stays_id,
          },
          {
            name: "accommodation_stays_id_name",
            label: "Acomodação",
            type: "input",
            getIsDisabled: () => !!defaultData?.reservation_stays_id,
          },
        ],
        [
          {
            name: "check_in",
            label: "Entrada",
            type: "input",
            getIsDisabled: () => !!defaultData?.reservation_stays_id,
          },
          {
            name: "check_out",
            label: "Saída",
            type: "input",
            getIsDisabled: () => !!defaultData?.reservation_stays_id,
          },
        ],
      ],
      customContent: (
        <Flex gap={22} align='end'>
          <Flex direction='column' style={{ flex: 1 }}>
            <label style={{ fontSize: '13px', marginBottom: '5px', fontWeight: 500 }}>Link do Checkin</label>
            <Input
              name='linkCheckIn'
              disabled={true}
              value={defaultData?.checkinLink}
            />
          </Flex>

          <Button
            onClick={handleCopy}
            background={secondary[theme]}
            color={"#FFF"}
            style={{ padding: 8, maxWidth: 80, maxHeight: 38, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1px' }}
            children={<FaRegCopy size={20} />}
          />
        </Flex>
      ),
      customExtraHeader: (
        <Flex
          gap={10}
          align="center"
          justify="space-between"
          sx={(theme) => ({
            flexDirection: 'row',
            [`@media (max-width: 930px)`]: {
              flexDirection: 'column',
            },
          })}
        >
          {defaultData?.check_in_id && user.user_type.permissions.includes("STAYS-RESERVATIONS-CHECK-INS-DELETE" as IPermissionsTypes) && (
            <Button
              onClick={() => alertDelete(defaultData)}
              background='transparent'
              leftIcon={<MdDelete color={fail} size={18} />}
              color={fail}
              borderColor={fail}
              children="Excluir check-in"
              disabled={disabledCheckin}
              style={{ paddingTop: 10, paddingBottom: 10, minWidth: 158, minHeight: 43 }}
            />
          )}

          {defaultData?.is_have_contract_model && (
            <Button
              onClick={() => window.open(`/contract-reservation?reservation_id=${defaultData?.reservation_stays_id}`, "_blank")}
              background='transparent'
              leftIcon={<LiaFileContractSolid color={secondary[theme]} size={21} />}
              color={secondary[theme]}
              borderColor={secondary[theme]}
              children="Contrato"
              disabled={disabledCheckin}
              style={{ paddingTop: 10, paddingBottom: 10 }}
            />
          )}

          <DropdownButton
            className={'message-reservation'}
            options={[
              {
                id: 2,
                text: "Enviar email",
                onClick: () => setSelectedCheckInSendEmail(defaultData),
                icon: <MdOutlineEmail color={secondary[theme]} size={20} />,
                disabled: () => !user.user_type.permissions.includes("SEND_EMAILS" as IPermissionsTypes) || !isHaveAcessInstructionsPermission,
              },
              {
                id: 3,
                text: "Enviar WhatsApp",
                onClick: () => setSelectedCheckInSendWpp(defaultData),
                icon: <FaWhatsapp color={secondary[theme]} size={20} />,
                disabled: () => !user.user_type.permissions.includes("SEND_WPP" as IPermissionsTypes) || !isHaveAcessInstructionsPermission, //TEM QUE FUNCIIONA
              },
            ]}
            loading={false}
            main_option={{ text: "Enviar mensagem", id: 84585 }}
            onClick={() => { }}
            icon={<IoSend color={'#FFF'} size={16} />}
            theme={theme}
            zIndex={900}
          />
        </Flex>
      )
    },
  ];

  useEffect(() => {
    const inputs = document.getElementsByTagName("input");
    for (let i = 0; i < inputs.length; i++)
      inputs[i].setAttribute("autocomplete", "new-password");
  }, [_form.access_type]);

  useEffect(() => {
    guestsMediator.updateGuests(guestsGroups);
  }, [guestsGroups]);


  return (
    <>
      <Form onSubmit={handleStopPropagation}>
        <BlockForm
          ref={form_ref}
          groups={groupsReservations}
          _form={_form}
          control={control}
          trigger={trigger}
          errors={errors}
          setValue={setValue}
          register={register}
        />

        {(!isDoneCheckIn && !isOpenCheckIn) && (
          <Flex direction='column' gap={20} style={{ marginTop: -20 }}>
            <Alert icon={<FiAlertCircle size="1.1rem" />} title={disabledCheckin ? 'Check-in desabilitado' : 'Check-in não realizado!'} style={{
              backgroundColor: theme === "dark" ? 'rgba(250,176,5,.15)' : 'rgba(250,176,5,.1)',
              color: theme === "dark" ? '#FFE066' : '#FAB005',
            }}>
              <Text color={theme === "dark" ? '#fff' : '#3A3A3A'} style={{ fontFamily: 'Poppins' }}>
                {disabledCheckin ? 'Check-in habilitado somente para reservas com status (RESERVADO)' : 'Clique no botão abaixo para realizar o check-in.'}
              </Text>
            </Alert>

            <Button
              onClick={() => handleStartNewCheckIn({ reservation_stays_id: defaultData })}
              background={secondary[theme]}
              color={"#FFF"}
              style={{ padding: 8, maxWidth: 200, fontSize: 14 }}
              children="Realizar Check-In"
              disabled={disabledCheckin}
            />
          </Flex>
        )}

        {(isDoneCheckIn || isOpenCheckIn) && (
          <Flex direction='column' gap={30} style={{ marginTop: -20 }}>
            <FormCheckIn
              guestsDocumentsRefs={guestsDocumentsRefs}
              _form={_form}
              addGuestGroup={addGuestGroup}
              buttonSubmitRef={buttonSubmitRef}
              guestsGroups={guestsGroups}
              getGuests={getGuests}
              guestsRefs={guestsRefs}
              loadingSave={loadingSave}
              removeOwnerGroup={removeOwnerGroup}
              control={control}
              errors={errors}
              trigger={trigger}
              setValue={setValue}
              setError={setError}
              clearErrors={clearErrors}
              register={register}
            />
          </Flex>
        )}
      </Form >

      <ModalLoading loading={loadingSave} theme={theme} />

      {selectedCheckInSendWpp?.id && (
        <ModalSendWpp
          onCancel={() => setSelectedCheckInSendWpp(null)}
          onSave={() => setSelectedCheckInSendWpp(null)}
          openModal={!!selectedCheckInSendWpp?.id}
          id={selectedCheckInSendWpp?.reservation_stays_id as any}
        />
      )}
      {selectedCheckInSendEmail && (
        <ModalSendEmail
          onCancel={() => setSelectedCheckInSendEmail(null)}
          onSave={() => setSelectedCheckInSendEmail(null)}
          openModal={!!selectedCheckInSendEmail}
          id={selectedCheckInSendEmail.reservation_stays_id as any}
        />
      )}
    </>
  );
};
